
// src/pages/MS/MIN101F1.jsx
import React, {useEffect, useState} from 'react';
import style from "./MIN101F1.module.scss";

import {postData} from "utils/TransactionUtil";
import Modal from "components/Modal/Modal";
import DataGrid from "components/DataGrid/DataGrid";
import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";

import MIN101F2 from "pages/MI/MIN101F2";

const MIN101F1 = ({navBar: NavBar}) => {

    //검색 조건
    const [schUserNm, setSchUserNm] = useState('');

    //사용자리스트
    const [rows_NoticeList, setRows_NoticeList] = useState([]);
    const cols_NoticeList = [
        { key: 'sqnc',           name: 'NO',      width: '5%', renderCell: ({ rowIdx }) => rowIdx+1},
        { key: 'titlNm',         name: '제목',     width: '50%', cellClass: 'align_left' },
        { key: 'qstnRespCtryNm', name: '카테고리',  width: '15%' },
        { key: 'frstRgstDt',     name: '작성일',    width: '20%'},
        { key: 'frstRgsrNm',     name: '작성자명',  width: '10%'},
    ];

    const [ntceId, setNtceId] = useState();

    const [isModalOpen, setIsModalOpen] = useState(false); //모달 오픈여부(사용자 상세)

    useEffect(() => {

        getNoticeList(); //그룹 공통 코드 조회

    }, []);

    const handleClick_search = () => {
        getNoticeList().then(r => {});
    }

    // 검색값 입력후 엔터
    const handleKeyDown_schUserNm = (e) => {
        //e.preventDefault();

        if (e.key === 'Enter') {
            getNoticeList().then(r => {});
        }
    };

    async function getNoticeList(){
         const param = {
            schUserNm : schUserNm
        }
        const res = await postData("/MIN/getNoticeList", param);
        setRows_NoticeList(res);
    }

    const handleDblClick_NoticeList = (e) => {
        setNtceId(e.row.ntceId);
        setIsModalOpen(true);
    }

    //사용자 상세 팝업 닫기
    const handleModal_Close = () => {
        //e.preventDefault();
        setIsModalOpen(false);
    }

    return(
        <main className={style.main_wrap}>
            <NavBar>
                {/*Nav 내용*/}
            </NavBar>
            {/*검색영역*/}
            <div className={style.search_wrap}>
                <span className={style.schTitle}>작성자명</span>
                <input
                    type="text"
                    className={style.schUserNm}
                    defaultValue={schUserNm}
                    onChange={(e) => setSchUserNm(e.target.value)}
                    name="schUserNm"
                    maxLength={'12'}
                    placeholder="작성자명 또는 ID 검색"
                    onKeyDown={(e) => handleKeyDown_schUserNm(e)}
                />
                <Button variant="default" size="md" addStyle={{width: "70px", height: "38px"}}
                        onClick={() => handleClick_search()}>
                    조회<Icon id="rightAngleBrackets_02" width="16" height="16"/>
                </Button>
            </div>
            {/*내용*/}
            <div className={style.main_wrap}>
                <DataGrid
                    cols={cols_NoticeList}
                    rows={rows_NoticeList}
                    size='md'
                    headerRowHeight={45}
                    rowHeight={30}
                    onCellDoubleClick={(e) => handleDblClick_NoticeList(e)}
                    sortable={true}
                    isNodataView={true}
                    isRowColorful={false}
                />
            </div>
            <Modal
                open={isModalOpen}
                handle_Close={handleModal_Close}
                title="공지사항 상세"
                width ="900px"
                height="1500px"
                isHeader={true}
                isBottom={false}>
                <MIN101F2 handle_Close={handleModal_Close} ntceId = {ntceId}/>
            </Modal>
        </main>
    )
}
export default MIN101F1;
